import { render } from "./Chat_Thread.vue?vue&type=template&id=de8e476e"
import script from "./Chat_Thread.vue?vue&type=script&lang=js"
export * from "./Chat_Thread.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__